function throttle(fn, timeout) {
  let ready = true;

  return (...args) => {
    if (!ready) {
      return;
    }

    ready = false;
    fn(...args);

    setTimeout(() => {
      ready = true;
    }, timeout)
  }
}
export {throttle};



// WEBPACK FOOTER //
// ./src/components/scroll-progress/helpers/throttle.js